export default __webpack_public_path__ + "static/media/JGONZALES.e545eb6d.jpg";